import { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { AIAssistantProvider } from "@/context/AIAssistantContext";

const AdminLayout = ({ children }) => {
  const location = useLocation();
  // Auth + page-name helpers were used by the floating AI Assistant (now removed).
  // AdminLayout is intentionally minimal — it just provides AIAssistantProvider for
  // the POS page-control context. The AI itself lives in /admin/messages.

  return (
    <AIAssistantProvider>
      {children}
      {/* Floating AI Assistant FAB removed — AI now lives in the Internal Messenger
          (/admin/messages) as the pinned "AI Tailor" thread and @ai mentions.
          AIAssistantProvider kept because AdminPOSPage still registers page handlers. */}
    </AIAssistantProvider>
  );
};

export default AdminLayout;
